import { motion, AnimatePresence } from "framer-motion";

const STEP_HINTS: Record<number, { emoji: string; text: string }> = {
  0: { emoji: "👤", text: "Dis-nous qui tu es pour personnaliser ton expérience !" },
  1: { emoji: "🌍", text: "Choisis ton pays pour adapter le programme scolaire." },
  2: { emoji: "📚", text: "Sélectionne ton niveau d'études actuel." },
  3: { emoji: "🏫", text: "Indique ta classe pour des cours sur mesure." },
  4: { emoji: "📖", text: "Choisis les matières que tu veux étudier avec l'IA." },
  5: { emoji: "🎯", text: "Quel est ton objectif ? Cela aide l'IA à mieux t'accompagner." },
  6: { emoji: "😊", text: "Choisis un avatar qui te représente !" },
};

const PARENT_HINTS: Record<number, { emoji: string; text: string }> = {
  0: { emoji: "👤", text: "Renseignez vos informations pour créer votre profil parent." },
  1: { emoji: "🔗", text: "Entrez le matricule KelasAI de votre enfant pour le suivre." },
  2: { emoji: "😊", text: "Choisissez votre avatar !" },
};

type Props = {
  step: number;
  isParent: boolean;
};

const OnboardingGuide = ({ step, isParent }: Props) => {
  const hints = isParent ? PARENT_HINTS : STEP_HINTS;
  const hint = hints[step];
  if (!hint) return null;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={step}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
        className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl bg-primary/5 border border-primary/15 mb-4"
      >
        <span className="text-lg">{hint.emoji}</span>
        <p className="text-xs font-semibold text-foreground leading-relaxed">{hint.text}</p>
      </motion.div>
    </AnimatePresence>
  );
};

export default OnboardingGuide;
